import { Mail, MapPin, Phone } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import { useConfig } from "@/hooks/useConfig";
import { mapLink, telHref } from "@/lib/format";
import MapEmbed from "@/components/MapEmbed";

const ADDRESS = "Village Bujhda, Tehsil Girwa Road, Kodiyat, Udaipur, Rajasthan 313031";
const MAPQ = "The Ananta Udaipur, Village Bujhda, Kodiyat, Udaipur, Rajasthan";

export default function Contact() {
  useSeo("Contact Us - The Ananta Udaipur", "Contact The Ananta Udaipur and The Ananta Hotels reservations. Phone, WhatsApp, email and address in Kodiyat, Udaipur.");
  const cfg = useConfig();
  const wa = `https://wa.me/${cfg.whatsapp}?text=${encodeURIComponent("Hello Ananta Hotels, I have an enquiry.")}`;
  return (
    <section className="container-x py-16 sm:py-24">
      <p className="eyebrow text-[#C28B5E]">Contact us</p>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl text-[#1E3B2E] tracking-tight">We're here to help</h1>
      <div className="mt-14 grid lg:grid-cols-3 gap-10">
        <div className="space-y-8 text-sm" data-testid="contact-details">
          <div>
            <p className="eyebrow text-[#6b6b6b] mb-3">The Ananta Udaipur</p>
            <p className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0" /><span data-testid="contact-address">{cfg.address || ADDRESS}</span></p>
          </div>
          <div className="space-y-3">
            <p className="eyebrow text-[#6b6b6b]">Phone &amp; WhatsApp</p>
            <a href={telHref(cfg.contact_phone)} className="flex gap-3 hover:text-[#C28B5E]" data-testid="contact-phone"><Phone size={16} />{cfg.contact_phone}</a>
            {cfg.central_phone && <a href={telHref(cfg.central_phone)} className="flex gap-3 hover:text-[#C28B5E]" data-testid="contact-central-phone"><Phone size={16} />{cfg.central_phone} (Central reservations)</a>}
          </div>
          <div className="space-y-3">
            <p className="eyebrow text-[#6b6b6b]">Email</p>
            <a href={`mailto:${cfg.central_email}`} className="flex gap-3 hover:text-[#C28B5E]" data-testid="contact-email"><Mail size={16} />{cfg.central_email}</a>
          </div>
          <div className="flex flex-wrap gap-3">
            <a href={wa} target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="contact-whatsapp-btn">WhatsApp us</a>
            <a href={mapLink(MAPQ)} target="_blank" rel="noopener noreferrer" className="btn-ghost text-[#1E3B2E] hover:bg-[#1E3B2E] hover:text-white" data-testid="contact-directions-btn">Directions</a>
          </div>
        </div>
        <div className="lg:col-span-2"><MapEmbed query={MAPQ} title="The Ananta Udaipur map" /></div>
      </div>
    </section>
  );
}
